// Legacy JS Code related to the first static versions of the forms.
var ame = {};

    ame.handleNumberedListAdd = function(btn) {
        var list = btn.closest('.numbered-list');
        var lastRow = list.find('> div.numbered-list-item').last();
        var newRow = lastRow.clone();
        newRow.find('textarea').val('');
        newRow.find('input').val('');
        lastRow.after(newRow);

        var numberElem = newRow.find('.numbered-list-number').first();
        if (numberElem.length !== 0) {
            var integer = parseInt(numberElem.html().slice(0, -1), 10);
            if (!isNaN(integer)) {
                numberElem.html((integer + 1) + '.');
            }
        }

        newRow.find('textarea[data-character-limit]').each(function() {
            new TextareaCharCounter(this);
        });
        newRow.find('textarea[data-word-limit]').each(function() {
            new TextareaWordCounter(this);
        });
        newRow.find('input[data-validate]').each(function() {
            new InputValidator(this);
        });
        newRow.find('[data-sum-item]').each(function() {
            new SumCalculator(this);
        });
        newRow.find('.add-row-to-numbered-list-button').on('click', function() {
            return ame.handleNumberedListAdd(jQuery(this));
        });
        newRow.find('.numbered-list-item-remove').on('click', function() {
            return ame.handleNumberedListItemRemove(jQuery(this));
        });

        // if (typeof (list.data('add-callback')) !== 'undefined') {
        //     eval('('+list.data('add-callback')+')')(newRow);
        // }

        ame.initBeneficiaryCount();
        ame.initPartnerFinancingTotalCalculation();

        return false;
    };


    ame.handleNumberedListItemRemove = function(btn) {
        var item = btn.closest('.numbered-list-item');
        var list = item.closest('.numbered-list');

        if (list.find('> .numbered-list-item').length > 1) {
            if (confirm(btn.attr('data-confirm'))) {
                item.remove();
            }
        }
        list.find('> .numbered-list-item').each(function(i) {
            jQuery(this).find('.numbered-list-number').first().html((i + 1) + '.');
        });
        list.find('[data-sum-item]').each(function() {
            jQuery(this).trigger('update-sum');
        });

        ame.initBeneficiaryCount();
        ame.initPartnerFinancingTotalCalculation();

        return false;
    };


    ame.ready = function() { // pre-formeditor form that can't be accessed for new funds (nothing will ever be edited there)
        var form = jQuery('.concept-note-form');
        //console.log(form)
        if (!form.is('.draft') || (form.is('.phase-ended') && !form.is('.extension-period')) || form.is('.readonly')) {
            $('li.pdf-export').removeAttr('title');

            form.find('input, select, textarea').prop('disabled', true);

            jQuery('.full-details-toggle').off('click').on('click', function() {
                var link = jQuery(this)
                var labelTmp = link.text();
                link.text(link.attr('data-toggle-with')).attr('data-toggle-with', labelTmp);
                jQuery('.concept-note-form').fadeToggle();
                return false;
            });

            ame.convertFormToPrintable(form);
        } else {
            $('li.pdf-export').tooltip();

            form.find('input:not(".locked"), select:not(".locked"), textarea:not(".locked")').prop('disabled', false);

            $('.add-row-to-numbered-list-button').on('click', function() {
                return ame.handleNumberedListAdd(jQuery(this));
            });

            $('.numbered-list-item-remove').on('click', function() {
                return ame.handleNumberedListItemRemove(jQuery(this));
            });

            $('#add-project-member-button').on('click', function() {
                var btn = $(this);
                panel = $(this).closest('div.row').prev('.project-member-panel');
                var newPanel = panel.clone();
                newPanel.find('textarea').val('');
                newPanel.find('input').val('');
                panel.after(newPanel);

                newPanel.find('textarea[data-character-limit]').each(function() {
                    new TextareaCharCounter(this);
                });
                newPanel.find('textarea[data-word-limit]').each(function() {
                    new TextareaWordCounter(this);
                });
                newPanel.find('input[data-validate]').each(function() {
                    new InputValidator(this);
                });
            });

            $('.project-team-members').on('click', '.remove-project-member-button', function() {
                if (confirm('Are you sure you want to remove this person from the project team?')) {
                    $(this).parents('.project-member-panel').remove();
                }
            });

            // Attachments
            AttachmentUploader.init();

            // Character counters
            jQuery('textarea[data-character-limit]').each(function() {
                new TextareaCharCounter(this);
            });

            // Word counters
            jQuery('textarea[data-word-limit]').each(function() {
                new TextareaWordCounter(this);
            });
            
            // Validations
            jQuery('input[data-validate]').each(function() {
                new InputValidator(this);
            });

            // Total sums
            jQuery('[data-sum-item]').each(function() {
                new SumCalculator(this);
            });

            jQuery('form').on('submit', function() {
                var isValid = true;

                // Execute all validators
                jQuery('input[data-validate]').each(function() {
                    jQuery(this).trigger('validate');
                    isValid = (isValid && !jQuery(this).is('[data-invalid]'));
                });

                // If invalid scroll to the first invalid input
                if (!isValid) {
                    var firstInvalid = jQuery('[data-invalid]').first();
                    jQuery(window).scrollTop(firstInvalid.offset().top - jQuery('#navbar').outerHeight() - 30);
                }

                return isValid;
            });

            jQuery('.select2').select2();

            // GFS district selection
            jQuery('#concept_note_applicant_office_location_2').on('change', function() {
                var districtSelect = jQuery('#concept_note_applicant_office_location_1');
                districtSelect.select2('destroy');
                districtSelect.find('option').remove();
                if (typeof(jQuery(this).data('data')[jQuery(this).val()]) != 'undefined') {
                    jQuery.each(jQuery(this).data('data')[jQuery(this).val()], function(l, opt) {
                        districtSelect.append(jQuery('<option>').val(opt[0]).text(opt[1]));
                    });
                }
                districtSelect.select2();
            })

            jQuery(document).on('sms:opened', function(e, type, identifier) {
                jQuery('.concept-note-form input[name="concept_note[confirmation_code]"]').val(identifier);
            })

            jQuery(document).on('sms:success', function(e, type){
                if (type == 'concept_note_submit') {
                    var input = jQuery("<input>").attr("type", "hidden").attr("name", "status").val("submitted");
                    jQuery('.concept-note-form').append(input);
                    jQuery('.concept-note-form').submit();
                }
            });
            jQuery(document).on('sms:failed', function(e, type){
            });
        }

        new SumCalculator().updateAll();

        ame.initProjectDurationCalculation();
        ame.initBeneficiaryCount();
        ame.initPartnerFinancingTotalCalculation();

        // for Ghana form 1
        ame.initContactPersonRows();
        // Removed as unused functionality with migration to flatpickr
        // jQuery('input.datetimepicker').datetimepicker({format: "YYYY-MM-DD"});
        // #TODO: Test before use.
        jQuery('input.datetimepicker').flatpickr({format: "Y-m-d", allowInput: true});
    };


    ame.convertFormToPrintable = function(formSelector) {
        var form = jQuery(formSelector);

        form.find('textarea').each(function() {
            var area = jQuery(this);
						//area.replaceWith('<div class="printable-textarea">' + area.val().replace(/\n/g, '<br />') + '</div>');
						area.replaceWith(jQuery('<div>').addClass('printable-textarea').attr('data-name', area.attr('name')).html(area.val().replace(/\n/g, '<br />')))
        });

        form.find('input[type="text"]').each(function() {
            var input = jQuery(this);
            input.replaceWith(jQuery('<div>').attr('id', input.attr('id')).addClass('printable-input-text').addClass(input.attr('class')).removeClass('form-control').attr('data-name', input.attr('name')).html(input.val()));
        });

        form.find('select').each(function() {
            var select = jQuery(this);
						//select.replaceWith('<div class="printable-select">' + jQuery(this.options[this.selectedIndex]).html() + '</div>');
						select.replaceWith(jQuery('<div>').addClass('printable-select').attr('data-name', select.attr('name')).html(jQuery(this.options[this.selectedIndex]).html()));
        });

        form.find('input[type="checkbox"]').each(function() {
            var input = jQuery(this);
            if (input.is(':checked')) {
								//input.replaceWith('<span class="printable-input-checkbox">&#x2713;</span>');
								input.replaceWith(jQuery('<span>').addClass("printable-input-checkbox").attr('data-name', input.attr('name')).html("&#x2713;"));
            } else {
								//input.replaceWith('<span class="printable-input-checkbox">&nbsp;</span>');
								input.replaceWith(jQuery('<span>').addClass("printable-input-checkbox").attr('data-name', input.attr('name')).html("&nbsp;"));
            }
        });

        form.find('input[type="radio"]').each(function() {
            var input = jQuery(this);
            if (input.is(':checked')) {
								//input.replaceWith('<span class="printable-input-radio"><span class="bullet"></span></span>');
								input.replaceWith(jQuery('<span>').addClass("printable-input-radio").html(jQuery('<span>').addClass("bullet").attr('data-name', input.attr('name'))));
            } else {
								//input.replaceWith('<span class="printable-input-radio">&nbsp;</span>');
								input.replaceWith(jQuery('<span>').addClass("printable-input-radio").attr('data-name', input.attr('name')));
            }
        });

				form.find('.dropzone').each(function(){
						var input = jQuery(this);
						var dz = jQuery(this).find('.attachment-pointer')
						input.addClass('printable-dropzone').attr('data-name', dz.attr('name') )
				});
				form.find('.sdg').each(function(){
					var input = jQuery(this);
					input.attr('data-name', input.attr('name'));
				})

        form.find('.repeatable_region').addClass('printable-repeatable-region');

        form.find('.btn').remove();
    }


    ame.initProjectDurationCalculation = function() {
        var update = function() {
            var start = jQuery('#concept_note_project_end_date').val() || jQuery('#concept_note_project_end_date').text() 
            var end = jQuery('#concept_note_project_start_date').val() || jQuery('#concept_note_project_start_date').text() 
            var dur = Math.floor((new Date(start) - new Date(end)) / (1000 * 60 * 60 * 24 * 30.42));
            jQuery('#project-period .project-period-duration').html((dur || '') + ' months');
        }
        jQuery('#concept_note_project_end_date, #concept_note_project_start_date').on('change', update);
        update();
    }


    ame.initBeneficiaryCount = function() {
        var update = function(){
            jQuery('#beneficiaries').find('.numbered-list-item').each(function(i,e) {
                var maleCount = parseInt(jQuery(e).find('[name="concept_note[beneficiaries][][male_count]"]').val() || jQuery(e).find('[name="concept_note[beneficiaries][][male_count]"]').text()) || 0;
                var femaleCount = parseInt(jQuery(e).find('[name="concept_note[beneficiaries][][female_count]"]').val() || jQuery(e).find('[name="concept_note[beneficiaries][][female_count]"]').text()) || 0;
                jQuery(e).find('.beneficiaries-total').html(maleCount+femaleCount);
            });
        };
        jQuery('#beneficiaries input').off('change').on('change', update);
        update();
    }


    ame.initPartnerFinancingTotalCalculation = function() {
        var currencyFields = jQuery('[name^="concept_note[financing_contributors]"]').filter('[name$="[euro]"]');
        var percentFields = jQuery('[name^="concept_note[financing_contributors]"]').filter('[name$="[percent]"]');
        
        if (jQuery('#partners-financing').length > 0 && currencyFields.length > 0) {
            var update = function(){
                jQuery('#partners-financing .total-cost-total-euro').html(currencyFields.map(function(i,e){
                        var value = jQuery(e).val() || jQuery(e).text();
                        return parseInt(value);}).get().reduce(function(sum, cur){ sum = sum || 0; return (cur || 0) + sum;
                    }) + ' &euro;');
                jQuery('#partners-financing .total-cost-total-percent').html(percentFields.map(function(i,e){
                        var value = jQuery(e).val() || jQuery(e).text();
                        return parseInt(value);}).get().reduce(function(sum, cur){ sum = sum || 0; return (cur || 0) + sum;
                    }) + ' %');
            };
            jQuery('#partners-financing input').off('change').on('change', update);
            update();
        }
    }


    ame.initContactPersonRows = function() {
        jQuery('body').delegate('.delete-contact-person-row', 'click', function(e) {
            if (confirm(I18n.t('confirm_row_delete'))) {
                jQuery(this).closest('.row.contact-person').remove();
            }
            e.preventDefault();
            return false;
        });

        jQuery('body').delegate('.new-contact-person-row', 'click', function(e) {
            jQuery('.contact-person-container').append(jQuery('#contact-person-template').clone().html());
            e.preventDefault();
            return false;
        });
    }


    /*
    * Sum calculator
    */
    function SumCalculator(element) {
        this.element = jQuery(element);
        this.sumId = this.element.attr('data-sum-item');
        this.element.on('change update-sum', jQuery.proxy(this.updateSum, this));
    };

    SumCalculator.prototype.calculateSum = function(sumId) {
        var sum = 0;
        jQuery('[data-sum-item="' + (sumId || this.sumId) + '"]').each(function() {
            if (this.value != '') {
                sum += parseFloat(jQuery(this).val());
            }
        });
        return sum;
    };

    SumCalculator.prototype.updateSum = function() {
        jQuery('[data-sum-total="' + this.sumId + '"]').val(this.calculateSum()).trigger('change');
    };

    SumCalculator.prototype.updateAll = function() {
        jQuery('[data-sum-total]').each(jQuery.proxy(function(i, item) {
            jQuery(item).val(this.calculateSum(jQuery(item).attr('data-sum-total'))).trigger('change');
        }, this));
    };


    /*
    * Input validator
    */
    function InputValidator(element) {
        this.element = jQuery(element);
        this.element.on('change validate', jQuery.proxy(this.validate, this));
    };

    InputValidator.prototype.validate = function() {
        var attrValue = null;
        var errors = [];

        if (attrValue = this.element.attr('data-validate-numeric')) {
            if (attrValue == 'true' && this.element.val() != '' && !this.element.val().match(/^\d+(\.\d+)?$/)) {
                errors.push(I18n.t('error_validate_numeric'));
            }
        }

        if (errors.length > 0) {
            this.element.popover({
                content: errors.join("<br />"),
                placement: 'bottom',
                trigger: 'manual',
                template: '<div class="popover validation-error" role="tooltip"><div class="arrow"></div><div class="popover-content"></div></div>'
            }).
            popover('show').
            attr('data-invalid', true);
            return false;
        }
        this.element.popover('hide').removeAttr('data-invalid');
        return true;
    };


    /*
    * Character counter for textareas
    */
    function TextareaCharCounter(textarea, options) {
        this.options = options || {};
        this.area = jQuery(textarea);
        this.options.limit = this.options.limit || this.area.attr('data-character-limit') || 0;

        this.initDisplay();
        this.updateCounter();
        this.area.on('keyup', jQuery.proxy(this.updateCounter, this));
    };

    TextareaCharCounter.prototype.initDisplay = function() {
        if (this.area.prev('.textarea-char-count').length == 0) {
            this.area.before('<span class="textarea-char-count"><span class="label label-default"><span class="current">0</span> / <span class="limit">0</span></span></span>');
        }
        this.display = this.area.prev('.textarea-char-count');
        this.display.find('.limit').html(this.options.limit);
    };

    TextareaCharCounter.prototype.updateCounter = function() {
        this.currentCount = this.area.val().length;

        if (this.currentCount > this.options.limit) {
            this.area.val(this.area.val().slice(0, this.options.limit));
            this.currentCount--;
            this.display.find('span.label').removeClass('label-default').addClass('label-info');
            return false;
        }
        this.display.find('.current').html(this.currentCount);
        this.display.find('span.label').removeClass('label-info').addClass('label-default');
        return true;
    };


    /*
    * Word counter for textareas
    */
    function TextareaWordCounter(textarea, options) {
        this.options = options || {};
        this.area = jQuery(textarea);
        this.options.limit = this.options.limit || this.area.attr('data-word-limit') || 0;

        this.initDisplay();
        this.updateCounter();
        this.area.on('keyup', jQuery.proxy(this.updateCounter, this));
    };

    TextareaWordCounter.prototype.initDisplay = function() {
        if (this.area.prev('.textarea-word-count').length == 0) {
            this.area.before('<span class="textarea-word-count"><span class="label label-default"><span class="current">0</span> / <span class="limit">0</span></span></span>');
        }
        this.display = this.area.prev('.textarea-word-count');
        this.display.find('.limit').html(this.options.limit);
    };

    TextareaWordCounter.prototype.updateCounter = function() {
        var text = this.area.val().replace(/^\s+/, '').replace(/\s+$/, '');
        var words = (text.length == 0 ? [] : text.split(/\s+/));

        this.currentCount = words.length;

        if (this.currentCount > this.options.limit && this.area.data('word-limit-allow-exceeding') !== true) {
            var regex = new RegExp('^((\\s*[\\S]+\\s+){0,' + this.options.limit + '}).+');
            this.area.val(this.area.val().match(regex)[1]);
            this.currentCount = this.options.limit;
        }

        if (this.currentCount < this.options.limit) {
            this.display.find('span.label').removeClass('label-info').addClass('label-default');
        } else {
            this.display.find('span.label').removeClass('label-default').addClass('label-info');
        }
        
        this.display.find('.current').html(this.currentCount);

        return;
    };


    /*
    * Attachment uploader
    */
    var AttachmentUploader = {

        init: function() {
            jQuery('#deleted-attachments').val('');

            jQuery('[data-upload-id]').each(function() {
                var uploadId = jQuery(this).attr('data-upload-id');

                // Browse action
                //
                jQuery(this).find('.browse-link').on('click', function() {
                    jQuery(this).closest('[data-upload-id]').find('input[type=\"file\"]').toggle();
                    return false;
                });

                // Drag and drop
                //
                var dropArea = jQuery('[data-upload-id="' + uploadId + '"] .upload-area');

                jQuery(this).find('input[type="file"]').fileupload({
                    dataType: 'json',
                    dropZone: dropArea,
                    add: function (e, data) {
                        jQuery.each(data.files, function(i, f) {
                            var oldFiles = dropArea.find('[data-file]');
                            oldFiles.each(function() {
                                jQuery(this).find('.glyphicon-remove').trigger('click');
                                jQuery(this).remove();
                            });
                            dropArea.append(jQuery('#attachment-template').html().
                                replace(/__filename__/g, f.name).
                                replace(/__iconclass__/g, 'repeat'));
                            dropArea.find('[data-file="' + f.name + '"] .glyphicon').
                                on('click', function() { return false; });
                        });
                        data.submit();
                    },
                    done: function (e, data) {
                        jQuery.each(data.files, function(i, f) {
                            dropArea.find('[data-file="' + f.name + '"] .glyphicon').
                                removeClass('glyphicon-repeat').addClass('glyphicon-remove').
                                off('click').on('click', AttachmentUploader.deleteNewAttachment);
                        });
                    }
                });

                // Delete files
                //
                jQuery(this).find('.upload-area [data-file] .glyphicon-remove').on('click', AttachmentUploader.deleteOldAttachment);

            });

        },


        deleteNewAttachment: function() {
            var fileContainer = jQuery(this).closest('[data-file]');
            var delUrl = jQuery(this).closest('[data-upload-id]').attr('data-delete-url');

            jQuery.post(delUrl, { filename: fileContainer.attr('data-file') });
            fileContainer.remove();
            return false;
        },


        deleteOldAttachment: function() {
            var fileContainer = jQuery(this).closest('[data-file]');

            // Update deleted attachments
            var deletedAttachments = (jQuery('#deleted-attachments').val() == '' ? [] : jQuery('#deleted-attachments').val().split(','));
            deletedAttachments.push(fileContainer.closest('[data-attachment-attr').attr('data-attachment-attr'));
            jQuery('#deleted-attachments').val(deletedAttachments.join(','));
            
            fileContainer.remove();
            return false;
        }
    };


window.ame = ame;